import React from 'react';
import { MuiFileInput } from 'mui-file-input';
import CloseIcon from '@mui/icons-material/Close';

export const FileInput = ({ file, handleChange }) => {
  return (
    <MuiFileInput
      placeholder="Select a file"
      value={file}
      onChange={handleChange}
      clearIconButtonProps={{
        title: 'Remove',
        children: <CloseIcon fontSize="small" />,
        value: '',
        onClick: () => handleChange(''),
      }}
    />
  );
};
